/**
 * in this module there are all the related functions for:
 *  - find suspension search events and behaviour
 */

import functions from '../common/functions'

/**
 * initialize the fault search
 */

const initSuspensionSearch = (view, overlay) => {
  /**
   * set the find fault datepicker to today date
   */

  let today = new Date()

  $('#psafindstamp').val(`${functions.leadZero(today.getDate())}/${functions.leadZero(today.getMonth() + 1)}/${today.getFullYear()}`)

  /**
   * set the datepicker options
   */

  $('#psafindstamp').datepicker({
    format: 'dd/mm/yyyy',
    autoclose: true,
    startDate: '01/01/1950',
    endDate: '+20y',
    orientation: 'bottom auto'
  }).on('show', function (e) {
    e.stopPropagation()
  })

  /**
   * hide the search list div
   */

  $('#psasearchcont').hide()

  /**
   * psafindbutton click handler
   */

  $('#psafindbutton').on('click', function () {
    /**
     * hide the popup
     */

    overlay.setPosition(undefined)

    /**
     * get the suspension id from the input
     */

    let getsusp = $('#psafindsusp').val()
    getsusp = getsusp.split(/,/g).join(' ')

    /**
     * get the hours selected element
     * get the selected hour
     */

    const sel = document.getElementById('frafindstamph')
    const hour = sel[sel.selectedIndex].value

    /**
     * get the date from the datepicker
     * create the final timestamp
     */

    let getstamp = $('#psafindstamp').val()

    if (getstamp !== '') {
      getstamp = getstamp.split('/').reverse().join('-')
      getstamp = `${getstamp} ${hour}`
    }
    else {
      getstamp = ''
    }

    /**
     * check the criteria and display the correct error
     */

    if ($('#psafindsusp').val() === '' && $('#psafindstamp').val() === '') {
      $('#psasearch_results').empty()
      $('#psasearchcont').show()
      $('#psasearch_results').append($('<h5 />', {
        text: 'Change the criteria.'
      }))
      return
    }

    /**
     * empty the search list div
     */

    $('#psasearch_results').empty()

    /**
     * create the json data
     */

    let theData = '{"findsusp": "' + getsusp + '", "findstamp": "' + getstamp + '"}'

    /**
     * send an ajax reuqest
     */
    $('.loading').show()
    $.ajax({
     url: '/traffweb/psa-find',
     type:"POST",
     data: {
       jdata: theData
     },
     beforeSend: function beforeSend(xhr) {
       xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
     }
    })
      .done((data) => {
        /**
         * parse the result if is the dev server with webpack
         */

        data = JSON.parse(data)

        $('#psasearchcont').show()
        /**
         * check if the response is empty
         * display an error
         */

        if (data.length === 0 || data.length === undefined) {
          $('#psasearch_results').empty()
          $('#psasearch_results').append($('<h5 />', {
            text: 'Suspension not found.'
          }))
          $('#psasearchcont').show()
        }

        /**
         * check if the response is just 1 result
         * move the map to the fault
         */

        else if (data.length === 1) {
          let zoom = view.getView().getResolutions()
          view.getView().setResolution(zoom[zoom.length - 1])
          view.getView().centerOn([parseFloat(data[0].easting), parseFloat(data[0].northing)], view.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])

          /**
           * check if it's a mobile device
           * hide the tools menu
           */

          if (functions.mobileTabletView()) {
            $('#dropdownToolsMobile').trigger('click')
          }
        }

        /**
         * else just show the result list
         */

        else {
          $('#psasearchcont').show()
        }

        /**
         * create the li item for each result
         */

        $.each(data, function () {
          /**
           * assign this to place
           */

          let place = this

          /**
           * create a li element
           * append the correct text
           * append to frasearch_results
           * add the click event
           *  - hide the popup
           *  - move the map
           * show psasearch_results
           */

          $('<li>')
            .append($('<a />', {
              text: `ID: ${place.suspid}, Log Time: ${place.stamp}`
            }))
            .appendTo('#psasearch_results').click(function () {
              overlay.setPosition(undefined)
              let zoom = view.getView().getResolutions()
              view.getView().setResolution(zoom[zoom.length - 1])
              view.getView().centerOn([parseFloat(place.easting), parseFloat(place.northing)], view.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])
            })
            .show()
        })
      }) // end done
      .fail(function (jqxhr, textStatus, error) {
        const err = `${textStatus}, ${error}`
        alert(`THEURLS Request Failed: ${err}`)
      })
      .always(() => {
        /**
         * hide the loading bar
         */

        $('.loading').hide()
      })
  })

  /**
   * when you press the ENTER key in the search input:
   *  - execute the find function emulating a click on the search button
   */

  $('#psafindsusp').keypress(function (e) {
    if (e.which === 13) {
      $('#psafindbutton').click()
    }
  })

/**
 * end const initSuspensionSearch = (view, overlay) => {
 */
}
/**
 * EXPORT
 */

export default {
  initSuspensionSearch,
}
